import { render, staticRenderFns } from "./CustomerAddressInputBlock.vue?vue&type=template&id=2c9574d6"
import script from "./CustomerAddressInputBlock.vue?vue&type=script&lang=ts"
export * from "./CustomerAddressInputBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports